"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var RadioButton_1 = __importDefault(require("stremio/components/RadioButton"));
var Choices_less_1 = __importDefault(require("./Choices.less"));
var Choices = function (_a) {
    var filter = _a.filter, query = _a.query, onSelect = _a.onSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var optionLabel = function (option) { return option.default ? t('ALL') : option.label; };
    var normalizedQuery = query.trim().toLocaleLowerCase();
    var options = filter.options.filter(function (option) {
        var _a;
        return "".concat(optionLabel(option), " ").concat((_a = option.description) !== null && _a !== void 0 ? _a : '').toLocaleLowerCase().includes(normalizedQuery);
    });
    return (react_1.default.createElement("div", { className: Choices_less_1.default['choices'], role: 'radiogroup', "aria-label": filter.label },
        options.map(function (option) { return (react_1.default.createElement(RadioButton_1.default, { key: option.value, className: Choices_less_1.default['choice'], selected: option.value === filter.value, ariaLabel: [optionLabel(option), option.description].filter(Boolean).join(' '), onChange: function () { return onSelect(option.value); }, label: react_1.default.createElement("span", { className: Choices_less_1.default['choice-copy'] },
                react_1.default.createElement("span", null, optionLabel(option)),
                option.description ?
                    react_1.default.createElement("span", { className: Choices_less_1.default['description'] }, option.description)
                    :
                        null) })); }),
        options.length === 0 ?
            react_1.default.createElement("div", { className: Choices_less_1.default['empty'], role: 'status' }, t('SEARCH_NO_RESULTS'))
            :
                null));
};
exports.default = Choices;
